import React from 'react';

import Quadrant from "../quadrant-view";
import TechnologyTag from "../technology-tag";

import { Technology } from "../../types/types";
import { getThemeByCategoryId } from '../../lib/themeHelper';
import { useTranslation } from 'react-i18next';


interface QuadrantContainerProps {
    scale: number;
    tags: Technology[];
    handleClick: (tag: Technology) => void;
    filter: { [key: string]: boolean; };
}

enum labelMap {
    Nische = 'Nische',
    Hoffnungsträger = 'Hoffnungsträger',
    Star = 'Star',
    Selbstläufer = 'Selbstläufer',
}

const QuadrantContainer: React.FC<QuadrantContainerProps> = ({ scale, tags , handleClick, filter}) => {
    const quadrants = Object.keys(labelMap).map((labelKey, index) => {
        const key = labelKey as keyof typeof labelMap;

        const { t } = useTranslation();

        return (
            <div key={index}>
                <Quadrant
                    className={`quadrant quadrant-${index}`}
                    label={t(labelMap[key])}
                    scale={scale}
                />
            </div>
        );
    });

    return (
        <>
            <TechnologyTag tags={tags} scale={scale} getTheme={getThemeByCategoryId} handleClick={handleClick} filter={filter}/>

            {quadrants}
        </>
    );
};
export default QuadrantContainer;